import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import type { ReactNode } from "react";

export function AppLayout({ children }: { readonly children?: ReactNode }) {
  return (
    <div className="min-h-[100dvh] flex flex-col lg:flex-row">
      <Sidebar />
      <main className="flex-1 lg:ml-64 px-4 py-5 sm:px-6 sm:py-6 lg:p-8 overflow-x-hidden">
        <div className="max-w-7xl mx-auto">
          {children || <Outlet />}
        </div>
        {/* Spacer for mobile bottom tab bar — ensures content never hides behind nav */}
        <div className="h-24 lg:hidden" aria-hidden="true" />
      </main>
    </div>
  );
}
